export default __webpack_public_path__ + "static/media/doctor_completed.e27bff51.png";